import React from "react";
import "./Project.scss";

// Libraries & Packages
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

// Components
import LandingBanner from "components/LandingBanner/LandingBanner";
import Footer from "components/Footer/Footer";
import Article from "components/Article/Article";
import TechnologyStack from "components/TechnologyStack/TechnologyStack";
import TitleL1 from "components/Titles/TitleL1/TitleL1";
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";
import useWindowWidth from "lib/Contentful/hooks/useWindowWidth";

function Project({ projectData }) {
  const { data, loading } = projectData;
  const windowWidth = useWindowWidth();

  return (
    <>
      {!loading && (
        <div className="project">
          <div className="project__baner">
            <LandingBanner
              title={data[0]?.fields.title}
              banner={`https:${data[0]?.fields.banner.fields.file.url}`}
            />
          </div>
          <div className="project__content">
            {/* Swiper */}
            <div className="project__swipper">
              <Swiper
                spaceBetween={20}
                slidesPerView={"auto"}
                freeMode={windowWidth < 800 ? true : false}
                pagination={{ clickable: true }}
                modules={[FreeMode, Pagination]}
              >
                {data[0]?.fields.gallery.map((image, i) => {
                  return (
                    <SwiperSlide key={i} style={{ width: "auto" }}>
                      <img src={`https:${image.fields.file.url}`} alt="" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            {/* Article */}
            <div className="project__article">
              <Article article={data[0]?.fields.article} />
            </div>
            {/* Technology Stack */}
            <div className="project__technologyStack">
              <AnimatedText>
                <TitleL1>Technology Stack</TitleL1>
              </AnimatedText>
              <TechnologyStack technologyData={data[0]?.fields.technology} />
            </div>
          </div>
          <div className="project__footer">
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

export default Project;
